<template>
	<div class="backstage-header">
		<!-- Topbar Start -->
		<div class="navbar-custom topnav-navbar navbar-backPage">
			<div class="container-fluid">
				<!-- LOGO -->
				<div class="topnav-logo">
					<span class="topnav-logo-lg"><img src="@/assets/images/yf_images/logo_bp_l.png" alt="" height="84" /></span>
					<span class="topnav-logo-sm"><img src="@/assets/images/yf_images/logo_bp_s.png" alt="" height="84" /></span>
				</div>
				<!-- LOGO右侧菜单 -->
				<ul class="list-unstyled topbar-right-menu float-right mb-0">
					<li class="dropdown notification-list">
						<a class="nav-link right-bar-toggle nav-home" href="javascript: void(0);">
							<i class="dripicons-home d-none d-sm-inline-block"></i>
							<span class="align-middle" @click="goFrontDesk">前台首页</span>
						</a>
					</li>
					<li class="dropdown notification-list d-none d-lg-block">
						<a class="nav-link right-bar-toggle nav-home" href="javascript: void(0);">
							<i class="mdi mdi-bank"></i>
							<span class="align-middle" @click="goBackstage">后台首页</span>
						</a>
					</li>
					<li><Login></Login></li>
				</ul>

				<!-- 一级导航 -->
				<nav class="navbar navbar-expand-lg navbar-light navbar-first">
					<button
						class="navbar-toggler"
						type="button"
						data-toggle="collapse"
						data-target="#navbarNavAltMarkup"
						aria-controls="navbarNavAltMarkup"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span class="navbar-toggler-icon"></span>
						<span class="ml-4">一级目录</span>
					</button>
					<div class="collapse navbar-collapse" id="navbarNavAltMarkup">
						<div class="navbar-nav">
							<!-- <a class="nav-link d-lg-none d-block" href="#">后台首页</a> -->
							<div
								class="nav-link cursor_pointer"
								:class="{ active: curOneNavIndex == index }"
								v-for="(item, index) in menuList"
								:key="index"
								@click="goOtherPage1(index, item.path, item)"
							>
								{{ item.name }}
							</div>
						</div>
					</div>
				</nav>
			</div>
		</div>
		<!-- end Topbar -->

		<!-- 二级导航 -->
		<nav class="navbar navbar-two" v-if="isNavbarTwo && menuList[curOneNavIndex] && menuList[curOneNavIndex].children">
			<ul class="nav">
				<template v-for="(item, index) in menuList[curOneNavIndex].children">
					<li
						v-if="
							(item.path !== 'expertScoreList' && item.path !== 'topicManageReviewList') ||
								((item.path == 'expertScoreList' || item.path == 'topicManageReviewList') && (item.isShow == 1 || !item.isShow))
						"
						class="nav-item cursor_pointer"
						:key="index"
						@click="goOtherPage2(index, item.path)"
					>
						<div class="nav-link" :class="{ active: curTwoNavIndex == index }">
							{{ item.name }}
							<span style="color: orange;">{{ getNotReviewNum(item.path) }}</span>
						</div>
					</li>
				</template>
				
			</ul>
		</nav>
		<!-- end Topbar -->
	</div>
</template>

<script>
import Login from '@/components/Login';
import { getReviewNum, getReviewNumOnTopicManage, projectNum } from '@/api/public.js';
import { getReviewAuthByUser } from '@/api/after/topicManage.js';
export default {
	name: 'HeaderAfter',
	components: { Login },
	data() {
		return {
			isUserLiLook: false,
			isNavbarTwo: false,
			menuList: JSON.parse(sessionStorage.getItem('menuList') || '[]'),
			curOneNavIndex: sessionStorage.getItem('curOneNavIndex') || 0,
			curTwoNavIndex: sessionStorage.getItem('curTwoNavIndex') || 0,
			userinfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
			projectData: {},
			unprocessedData: {
				//课题申报二级导航栏待处理数量
				//为处理数据
				districtNumber: 0,
				projectReview: 0,
				schoolNumber: 0
			},
			topicManageNotNum: {
				//课题管理二级导航待处理数
				openedSubjectNumber: 0,
				concludingApplyNumber: 0,
				quasiConcludingNumber: 0,
				midNumber: 0,
				concludingNumber: 0
			},
			number1: 0,
			number2: 0,
			number3: 0,
			number4: 0
		};
	},
	computed: {
		getNotReviewNum(val) {
			return val => {
				switch (val) {
					case 'schoolTopicReviewList':
						return this.unprocessedData.schoolNumber + '';
						break;
					case 'areaReviewList':
						return this.unprocessedData.districtNumber + '';
						break;
					case 'proposedProject':
						return this.unprocessedData.projectReview + '';
						break;
					// 课题管理二级导航未处理数量
					case 'openReview':
						return this.topicManageNotNum.openedSubjectNumber + '';
						break;
					case 'midtermReview':
						return this.topicManageNotNum.midNumber + '';
						break;
					case 'concludingApplication':
						return this.topicManageNotNum.concludingApplyNumber + '';
						break;
					case 'concludingReview':
						return this.topicManageNotNum.concludingNumber + '';
						break;
					case 'quasiConcluding':
						return this.topicManageNotNum.quasiConcludingNumber + '';
						break;
					case 'topicChange':
						return this.topicManageNotNum.conclusionNum + '';
						break;
					case 'schoolManage':
						return this.number1;
						break;
					case 'schoolManageAchievement':
						return this.number2;
						break;
					case 'schoolManageIndividual':
						return this.number3;
						break;
					case 'schoolManageCollective':
						return this.number4;
						break;
					default:
						break;
				}
			};
		}
	},
	watch: {
		$route: {
			handler(val) {
				console.log('当前路由', val);
				// console.log('pagelist',this.menuList);
				// console.log('page路由',val.path.split('/')[val.path.split('/').length-1]);
				let curMenuPath = val.path.split('/')[val.path.split('/').length - 1];
				// console.log('222',curMenuPath)
				// console.log(JSON.parse(JSON.stringify(this.menuList)))
				this.getMenuIndex(this.menuList, curMenuPath);
				this.projectData = JSON.parse(sessionStorage.getItem('projectData') || 'null');
				this.getReviewNumOnTopicManage()
				if (this.projectData) {
					this.getReviewNum();
					// this.getReviewNumOnTopicManage()
				}
				this.getTypeNum(1);
				this.getTypeNum(2);
				this.getTypeNum(3);
				this.getTypeNum(4);
			},
			immediate: true
		}
	},
	methods: {
		async getTypeNum(type) {
			const res = await projectNum({ type });
			if (res.code == 200) {
				if (type == 1) {
					this.number1 = res.data;
				}
				if (type == 2) {
					this.number2 = res.data;
				}
				if (type== 3) {
					this.number3 = res.data;
				}
				if (type== 4) {
					this.number4 = res.data;
				}
				// this.topicManageNotNum = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		async getReviewNumOnTopicManage() {
			const res = await getReviewNumOnTopicManage();
			if (res.code == 200) {
				console.log('课题管理未处理数量',res);
				this.topicManageNotNum = res.data
			}else{
				this.$message.error(res.data)
			}
		},
		async getReviewNum() {
			const res = await getReviewNum(this.projectData.id);
			if (res.code == 200) {
				console.log('未处理数据', res);
				this.unprocessedData = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 监听路由且根据当前用户菜单权限获取当前菜单栏索引
		getMenuIndex(menuList, curMenuPath) {
			console.log(menuList, curMenuPath);
			if (curMenuPath == 'topicsDeclaration' || curMenuPath == 'newProject') {
				this.isNavbarTwo = false;
				sessionStorage.removeItem('projectData');
			} else {
				this.menuList= JSON.parse(sessionStorage.getItem('menuList') || '[]');
				this.isNavbarTwo = true;
			}

			// 获取二级导航索引和数据
			let twoLevelNavObj = {};
			menuList.forEach(item => {
				if (item.children && item.children.length !== 0) {
					item.children.forEach((item1, index1) => {
						if (item1.path == curMenuPath) {
							this.curTwoNavIndex = index1;
							sessionStorage.setItem('curTwoNavIndex', this.curTwoNavIndex);
							twoLevelNavObj = item1;
						}
					});
				}
			});
			// 找到一级导航栏索引
			let oneLevelNavId; //申明一级菜单的ID
			if (Object.keys(twoLevelNavObj).length) {
				oneLevelNavId = twoLevelNavObj.parentId;
				menuList.forEach((item, index) => {
					if (item.id == oneLevelNavId) {
						this.curOneNavIndex = index;
						sessionStorage.setItem('curOneNavIndex', this.curOneNavIndex);
					}
				});
			} else {
				//如果路由在二级路由中没找到，那么在一级路由中寻找
				menuList.forEach((item, index) => {
					if (item.path == curMenuPath) {
						this.curOneNavIndex = index;
						sessionStorage.setItem('curOneNavIndex', this.curOneNavIndex);
					}
				});
			}
			console.log('计算出来', this.curOneNavIndex, this.curTwoNavIndex, curMenuPath);
		},
		goOtherPage1(index, url, item) {
			if (Object.keys(this.userinfo).length === 0) {
				this.$message.error('未登录，请登录！');
				this.$router.push('/index');
				return;
			}
			if (url == 'myTopic') {
				this.getReviewAuthByUser();
				if (this.userinfo.roleId.indexOf('2') > -1 || this.userinfo.roleId.indexOf('5') > -1) {
					//如果该用户是初审员或者课题管理员时跳转到在研课题汇总页面
					this.$router.push('/backstage/topicSummary');
				} else {
					this.$router.push('/backstage/myTopic');
				}
			} else if (url == 'articleManagement') {
				if (
					(this.userinfo.roleId.indexOf('2') && this.userinfo.roleId.indexOf('1') == -1) ||
					(this.userinfo.roleId.indexOf('5') && this.userinfo.roleId.indexOf('1') == -1)
				) {
					this.$router.push('/backstage/unitManagement');
				} else {
					this.$router.push('/backstage/' + url);
				}
			} else if (item.name == '征文评审' || item.name == '先进集体评选' || item.name == '先进个人评选' || item.name == '成果评奖') {
				let path = item.children[0].path;
				this.$router.push(`/backstage/${path}`);
			} else {
				this.$router.push('/backstage/' + url);
			}
		},
		// 判断当前专家的评审权限
		async getReviewAuthByUser(){
			const res = await getReviewAuthByUser()
			if (res.code == 200) {
				 let data = res.data;
				this.menuList.forEach((item,index)=>{
					if(item.path=='myTopic'){
						item.children.forEach((item1,index1)=>{
							if(item1.path=='topicManageReviewList'){
								this.menuList[index].children[index1].isShow=(data.internState || data.reviewState || data.finalState) ? 1 : 2
        						sessionStorage.setItem('menuList', JSON.stringify(this.menuList))
								this.$forceUpdate();
							}
						})
					}
				})
			}else{
				this.$message.error(res.data)
			}
		},
		goOtherPage2(index, url) {
			this.$router.push('/backstage/' + url);

			//    this.curTwoNavIndex = index;
			// sessionStorage.setItem('curTwoNavIndex', index)
		},
		goFrontDesk() {
			let routeUrl = this.$router.resolve({
				path: '/'
			});
			window.open(routeUrl.href, '_blank');
		},
		goBackstage() {
			let routeUrl = this.$router.resolve({
				path: '/backstage/index'
			});
			window.open(routeUrl.href, '_blank');
		}
	}
};
</script>

<style scoped lang="scss">
.cursor_pointer {
	cursor: pointer;
}
.login_box {
	::v-deep .el-form-item__label {
		padding: 0;
		line-height: 25px;
	}
}
.backstage-header{
	::v-deep .el-dialog__header {
		display: block;
	}
	::v-deep .el-dialog__body {
		padding-top: 0;
	}
	::v-deep .el-button--primary {
		background-color: #727cf5;
		border-color: #727cf5;
	}
}
</style>
